import React from "react";
import PropTypes from "prop-types";
import DiagnosticsPromoBox from "./DiagnosticsPromoBox";
import "./CartFooter.scss";
import { TOTAL_PAYABLE_AMOUNT } from "../../constants/index";
import { get, isEmpty } from "lodash";
import LoyaltyCartStrip from "../Loyalty/LoyaltyCartStrip";

const CartFooter = ({
  items,
  savings,
  actions,
  cartFareData,
  loyalty,
  loyaltyDetailsPitch,
  selectedLPVariant = {},
  loyaltyVariants,
  diagOrderBenefits,
  selectedDiagLPVariant,
  commonLPBenefits,
  programId,
  lpUserStatus,
  addToCartDiagLP,
  cartPlusSavings,
  selectedSlot,
}) => {
  const totalPayableAmount =
    cartFareData &&
    cartFareData.find(
      (fareDetail) => fareDetail.displayTextKey === TOTAL_PAYABLE_AMOUNT
    );

  const vasCharge = get(selectedSlot, 'charge')
  const cartValueTitle = vasCharge > 0 ? 'Cart Value' : 'Total Cart Value'

  return (
    <div className="footerDetails">
      {!isEmpty(loyaltyDetailsPitch) && (
        <LoyaltyCartStrip
          loyaltyDetailsPitch={loyaltyDetailsPitch}
          loyalty={loyalty}
          selectedVariant={selectedLPVariant}
          isDiagLoyaltyStrip
          diagLoyaltyVariants={loyaltyVariants}
          diagOrderBenefits={diagOrderBenefits}
          selectedDiagLPVariant={selectedDiagLPVariant}
          commonLPBenefits={commonLPBenefits}
          programId={programId}
          lpUserStatus={lpUserStatus}
          addToCartDiagLP={addToCartDiagLP}
          diagCartPlusSavings={cartPlusSavings}
        />
      )}
      <DiagnosticsPromoBox actions={actions} />
      <div className="summary">
        <div className="itemContainer">
          <div className="textTitle">Total Items</div>
          <div className="textTitle textbold">{items}</div>
        </div>
        <div className="itemContainer">
          <div className="textTitle textGreen">Total Savings</div>
          <div className="textTitle textbold textGreen">
            {savings.toFixed(2)}
          </div>
        </div>
        <div className="itemContainer">
          <div className="textTitle">{cartValueTitle}</div>
          <div className="textTitle textbold">
            {totalPayableAmount ? totalPayableAmount.discountedAmount : 0}
          </div>
        </div>

        {vasCharge > 0 && (
          <div className="itemContainer">
            <div className="textTitle">Vas Charge</div>
            <div className="textTitle textbold">
              {vasCharge}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CartFooter.propTypes = {
  items: PropTypes.number,
  savings: PropTypes.number,
  actions: PropTypes.object,
  cartFareData: PropTypes.array,
};

CartFooter.defaultProps = {
  items: 0,
  savings: 0,
  cartFareData: [],
};

export default CartFooter;
